export default "__VITE_ASSET__JcMO9QYR__"